import React from "react";
import { createPortal } from "react-dom";

function employeeName(emp) {
  return (
    emp.name ||
    emp.full_name ||
    [emp.first_name, emp.last_name].filter(Boolean).join(" ") ||
    emp.email ||
    "Employee"
  );
}

export default function CreateTeamDrawer({
  open,
  onClose,
  onSubmit,
  departments,
  employees,
}) {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 bg-slate-950/45 flex justify-end z-50">
      <div className="bg-white w-[440px] h-full shadow-2xl overflow-y-auto">
        
        {/* Header */}
        <div className="flex justify-between items-start gap-4 p-6 border-b border-slate-100 bg-gradient-to-br from-[#10233F] to-[#1D0B3D] text-white">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.3em] text-sky-200">
              Team Planner
            </p>
            <h2 className="mt-1 text-2xl font-black">Create Team</h2>
            <p className="mt-1 text-sm font-semibold text-slate-300">
              Group people by department and assign shared work.
            </p>
          </div>
          <button
            onClick={onClose}
            type="button"
            className="grid h-10 w-10 place-items-center rounded-full border border-white/15 bg-white/10 text-xl text-slate-100 hover:bg-white/20"
          >
            ✕
          </button>
        </div>

        {/* Form */}
        <form onSubmit={onSubmit} className="space-y-5 p-6">
          
          {/* Team Name */}
          <label className="block">
            <span className="mb-2 block text-sm font-bold text-slate-700">
              Team Name
            </span>
            <input
              name="name"
              placeholder="e.g. Product Delivery"
              className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-semibold text-slate-900 placeholder:text-slate-400 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100"
              required
            />
          </label>

          {/* Department */}
          <label className="block">
            <span className="mb-2 block text-sm font-bold text-slate-700">
              Department
            </span>
            <select
              name="department_id"
              className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-semibold text-slate-900 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100"
              required
            >
              <option value="">Select Department</option>
              {departments.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </select>
          </label>

          {/* Members */}
          <div>
            <div className="mb-2 flex items-center justify-between">
              <span className="text-sm font-bold text-slate-700">Members</span>
              <span className="rounded-full bg-sky-50 px-3 py-1 text-xs font-black text-sky-700">
                {employees.length} available
              </span>
            </div>
            <div className="max-h-56 overflow-y-auto rounded-3xl border border-slate-200 bg-slate-50 p-2">
              {employees.map((emp) => (
                <label
                  key={emp.id}
                  className="mb-2 flex cursor-pointer items-center gap-3 rounded-2xl bg-white px-3 py-3 text-sm font-bold text-slate-800 shadow-sm last:mb-0 hover:bg-sky-50"
                >
                  <input
                    type="checkbox"
                    name="members"
                    value={emp.id}
                    className="h-4 w-4 accent-sky-600"
                  />
                  <span className="min-w-0 flex-1">
                    <span className="block truncate">{employeeName(emp)}</span>
                    {emp.email && (
                      <span className="block truncate text-xs font-semibold text-slate-500">
                        {emp.email}
                      </span>
                    )}
                  </span>
                </label>
              ))}
              {!employees.length && (
                <p className="py-6 text-center text-sm font-semibold text-slate-500">
                  No employees found
                </p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="rounded-2xl bg-slate-200 px-5 py-3 text-sm font-black text-slate-700 hover:bg-slate-300"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="rounded-2xl bg-purple-600 px-5 py-3 text-sm font-black text-white shadow-lg shadow-purple-200 hover:bg-purple-700"
            >
              Create
            </button>
          </div>
        </form>
      </div>
  
    </div>,
        document.body
  );
}
